export function hasHtml(text: string): boolean {
  return /<\/?[a-z][\s\S]*>/i.test(text);
}

export function isMobile() {
  return window.innerWidth <= 767;
}